import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { Subscription } from 'rxjs';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { SdPriceComponent } from '../price/price.component';
import { AnimationsEnum } from '../../_enums/animations.enum';
import { DeviceService } from '../../_services/device.service';
import { ILink } from '../../_interfaces/link.interface';
import { IProductCard } from '../../_interfaces/product-card.interface';
import { ScrollSpyService } from '../../_services/scroll-spy.service';
import { SdButtonComponent } from '../buttons/button/button.component';
import { SdButtonIconComponent } from '../buttons/button-icon/button-icon.component';
import { SdIconComponent } from '../icons/icon/icon.component';
import { SdLibConfig } from '../../sd-lib-config';
import { SdListComponent } from '../lists/list/list.component';
import { SdSpyOnDirective } from '../../_directives/spy-on.directive';

@Component({
  selector: 'sd-page-navigation',
  templateUrl: './page-navigation.component.html',
  standalone: true,
  imports: [
    SdIconComponent,
    SdPriceComponent,
    SdListComponent,
    SdSpyOnDirective,
    SdButtonIconComponent,
    SdButtonComponent,
    TranslateModule
  ]
})
export class SdPageNavigationComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel: number;

  @Input()
  title: string;

  @Input()
  links: ILink[];

  @Input()
  product: IProductCard;

  @Input()
  isBundle: boolean;

  @Input()
  showLogo = true;

  @Input()
  isSSR = true;

  @ViewChild('activeBar', { read: ElementRef })
  activeBar: ElementRef;

  @ViewChildren('linksList')
  linksList: QueryList<ElementRef>;

  @Output()
  cart = new EventEmitter<void>();

  @Output()
  notify = new EventEmitter<void>();

  @Output()
  favorite = new EventEmitter<void>();

  @Output()
  openRecommendedPriceModal = new EventEmitter<void>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      !this.product?.stock?.online && !this.product?.onSale
        ? 'is-out-of-stock'
        : '',
      this.animation ? 'is-animation-' + this.animation : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  isDevice$: boolean;
  deviceSubscription: Subscription;
  scrollSpySubscription: Subscription;
  showWishList: boolean;
  animation: AnimationsEnum;
  animationEnum = AnimationsEnum;
  linkSelected: HTMLElement;

  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    private deviceService: DeviceService,
    private sdLibConfig: SdLibConfig,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    private scrollSpyService: ScrollSpyService,
    private viewportScroller: ViewportScroller,
  ) {
    const { wishList, animation } = this.sdLibConfig.get();
    this.showWishList = wishList;
    this.animation = animation;
  }

  ngOnInit() {
    this.deviceSubscription = this.deviceService.isDevice.subscribe((x) => {
      this.isDevice$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngAfterViewInit() {
    if (
      isPlatformBrowser(this.platformId) &&
      this.animation === AnimationsEnum.slide
    ) {
      this.scrollSpySubscription = this.scrollSpyService.activeSpyTarget
        .pipe(
          filter((target) => !!target),
          distinctUntilChanged(),
        )
        .subscribe((activeTarget) => {
          this.linkSelected =
            this.linksList?.toArray()[
              this.links?.findIndex((link) => link.url === activeTarget)
            ]?.nativeElement;
          if (this.linkSelected) {
            this.activeBarPosition(this.linkSelected);
          }
        });
    }
  }

  ngOnDestroy() {
    this.deviceSubscription?.unsubscribe();
    this.scrollSpySubscription?.unsubscribe();
  }

  selectLink(url: string, event: Event) {
    event.preventDefault();
    this.viewportScroller.scrollToAnchor(url);
  }

  activeBarPosition(selectedLink: HTMLElement) {
    this.renderer.setStyle(
      this.activeBar.nativeElement,
      'width',
      selectedLink.offsetWidth + 'px',
    );
    this.renderer.setStyle(
      this.activeBar.nativeElement,
      'left',
      selectedLink.offsetLeft + 'px',
    );
    this.renderer.setStyle(this.activeBar.nativeElement, 'opacity', 1);
  }

  addToFavorite() {
    this.favorite.emit();
  }

  stockNotify() {
    this.notify.emit();
  }

  addToCart() {
    this.cart.emit();
  }

  onopenRecommendedPriceModal() {
    this.openRecommendedPriceModal.emit();
  }
}
